// api/core/initialiseApi.ts
import { type AxiosInstance } from 'axios';
import { baseApiClient, setApiClient } from './apiClient';
import { createAuthInterceptors } from './auth/authInterceptor';

export const initialiseApi = (): AxiosInstance => {
    // Create the authenticated client
    const authenticatedClient = createAuthInterceptors(baseApiClient);

    // Set the global apiClient reference
    setApiClient(authenticatedClient);

    return authenticatedClient;
};
